// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-dashboard-box {\n  border: 1px solid #eee;\n  padding: 10px;\n  border-radius: 4px;\n}\n.empty-dashboard-box:hover {\n  background: #f9f9f9;\n  cursor: pointer;\n}\n.empty-dashboard-box .custom-icon .icon {\n  font-size: 38px;\n  color: #fe6100;\n}\n", ""]);
// Exports
module.exports = exports;
